import { Button, Flex, Image, Box } from "@chakra-ui/react";
import ResetSuccessSVG from "@root/assets/images/resetSuccessSVG.svg";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ResetSuccessHeading,
  ResetSuccessTopHeading,
  FormContainer,
} from "./styles";
import { useTranslation } from "react-i18next";
import { ROUTE_NAMES } from "@root/constants";
import { KPSLogoBig } from "@root/assets/icons";

export const ResetSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <FormContainer>
      <ResetSuccessTopHeading>
        <Box mt={"5rem"} mb={"15px"}>
          <KPSLogoBig />
        </Box>
      </ResetSuccessTopHeading>
      <Image src={ResetSuccessSVG} alt="ResetSuccess" mt="26px" />
      <ResetSuccessHeading>
        {t("resetPassword.resetSuccess")}
      </ResetSuccessHeading>
      <Flex alignItems={"center"} mt={"20px"}>
        <Button
          onClick={() => navigate(ROUTE_NAMES.LOGIN)}
          type="submit"
          colorScheme="purple"
          size="md"
          fontSize={"16px"}
          background={"purple.purpleGradient"}
          width={"190px"}
          borderRadius={"16px"}
        >
          {t("resetPassword.continueToLogin")}
        </Button>
      </Flex>
    </FormContainer>
  );
};
